
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { handleFill, moneyFormat } from "@/utils/util";
import StackedAreaChart from "@/components/StackedAreaChart/index.vue";

@Component({
  components: { StackedAreaChart },
})
export class DuringPeriod extends Vue {
  @Prop({ default: () => { } }) DuringTimeData: any
  handleFill = handleFill;
  moneyFormat = moneyFormat;
  totalMoneyMinWidth = 0

  @Watch("billData")
  onBillDataChange(newVal) {
    // 如果billData有值，获取van-col-6的宽度，计算total-moneye的最小宽度
    if (newVal && this.totalMoneyMinWidth === 0) {
      setTimeout(() => {
        const vanCol6Dom: any = document.getElementsByClassName('van-col-6')
        if (vanCol6Dom.length) {
          const vanCol6DomWidth = vanCol6Dom[0].offsetWidth
          this.totalMoneyMinWidth = vanCol6DomWidth - 24 // 24是total-money的margin-left的值
        }
      })
    }
  }
}
export default DuringPeriod;
